export enum TestResult {
  NOT_TESTED = 'NOT_TESTED',
  SUCCESS = 'PASS',
  FAIL = 'FAIL',
  NONE = 'NONE',
  NOT_REQUESTED = 'NOT_REQUESTED',
}
